import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/app-shell';
import { ProtectedRoute } from '@/router/protected-route';

// Auth Pages
import LoginPage from '@/pages/auth/login.page';
import SignupPage from '@/pages/auth/signup.page';
import ForgotPasswordPage from '@/pages/auth/forgot-password.page';
import ResetPasswordPage from '@/pages/auth/reset-password.page';
import VerifyEmailPage from '@/pages/auth/verify-email.page';
import AcceptInvitationPage from '@/pages/auth/accept-invitation.page';
import VerifyEmailPendingPage from '@/pages/auth/verify-email-pending.page';
import AuthCallbackPage from '@/pages/auth/auth-callback.page';

// Protected Pages
import DashboardPage from '@/pages/dashboard/dashboard.page';
import ProjectsPage from '@/pages/projects/projects.page';
import ProjectDetailPage from '@/pages/projects/project-detail.page';
import SettingsPage from '@/pages/settings/settings.page';
import OffcutsPage from '@/pages/offcuts/offcuts.page';
import ExportsPage from '@/pages/exports/exports.page';
import OptimisationRunsPage from '@/pages/optimisation/optimisation-runs.page';
import OptimisationRunDetailPage from '@/pages/optimisation/optimisation-run-detail.page';
import NotFoundPage from '@/pages/not-found.page';

/**
 * Centrally configured route tree using React Router DOM.
 * Splits public pages from protected workspace views wrapped in ProtectedRoute and AppShell.
 */
export const router = createBrowserRouter([
  // Public Routes
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '/accept-invitation',
    element: <AcceptInvitationPage />,
  },
  {
    path: '/verify-email-pending',
    element: <VerifyEmailPendingPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },

  // Protected Routes (scoped under ProtectedRoute HOC and AppShell)
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'projects',
        children: [
          { index: true, element: <ProjectsPage /> },
          { path: ':id/*', element: <ProjectDetailPage /> },
        ],
      },
      {
        path: 'settings/*',
        element: <SettingsPage />,
      },
      {
        path: 'optimisation',
        children: [
          { index: true, element: <OptimisationRunsPage /> },
          { path: 'runs', element: <OptimisationRunsPage /> },
          { path: 'runs/:id', element: <OptimisationRunDetailPage /> },
        ],
      },
      {
        path: 'offcuts',
        element: <OffcutsPage />,
      },
      {
        path: 'exports',
        element: <ExportsPage />,
      },
    ],
  },

  // Catch-all 404 Route
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
export default router;
